module.exports = __webpack_public_path__ + "img/wp-new-habit-card4.364f906e.jpg";